import { DateTime } from 'luxon'

import type { SATTestsBoundary } from '@/components/SATBootcamp/types'

export const GUIDANCE_COUNSELOR_EMAIL = 'guidance_counselor_email'

export function getSATScheduleOptions(testsBoundary: SATTestsBoundary) {
  const options = []

  const minDate = DateTime.fromISO(testsBoundary.minDate).startOf('month')
  const maxDate = DateTime.fromISO(testsBoundary.maxDate).startOf('month')

  const thisMonth = DateTime.local().startOf('month')
  for (let i = 0, length = 12; i < length; i += 1) {
    const optionMonth = thisMonth.plus({ months: i })

    if ((minDate != null && optionMonth < minDate) || (maxDate != null && optionMonth > maxDate)) {
      // No op
    } else {
      options.push({
        label: optionMonth.toFormat('LLLL yyyy'),
        value: optionMonth.toFormat('yyyy-LL'),
      })
    }
  }
  options.push(
    {
      label: 'Later',
      value: 'later',
    },
    {
      label: 'Already taken the SAT',
      value: 'already-taken',
    },
    {
      label: 'No plan on taking the SAT',
      value: 'no-plan',
    },
    {
      label: "I don't know",
      value: 'dont-know',
    }
  )

  return options
}
